export enum EContactActions {
    GET_CONFIG = 'GET_CONFIG',
    SEND_MESSAGE = 'SEND_MESSAGE',
}
